export class HelpdeskDashboard {
    public PendingOnIIAChapterLevel: string = "";
    public PendinOnUsersChapterLevel: string = "";
    public OpenFor15ChapterLevel: string = "";
    public OpenFor30ChapterLevel: string = "";
    public OpenFor30MoreChapterLevel: string = "";
    public OpenTicketChapterLevel: string = "";
    public ClosedTicketChapterLevel: string = "";
    public PendingOnIIACenterLevel: string = "";
    public PendingOnUsersCenterLevel: string = "";
    public OpenFor15CenterLevel: string = "";
    public OpenFor30CenterLevel: string = "";
    public OpenFor30MoreCenterLevel: string = "";
    public OpenTicketCenterLevel: string = "";
    public ClosedTicketCenterLevel: string = "";
}